import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';
import ListItemCheck from '@/views/components/ListItemCheck/ListItemCheck.vue';
import { ApartmentDTO, EntrancePlantDetailDTO } from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'GateAccessSection',
  components: {
    ListItemCheck
  },
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['onNewGates'],
  watch: {
    apartmentGates: {
      handler(newValue: string[]) {
        this.$emit('onNewGates', newValue);
      },
      deep: true
    }
  },
})

export default class GateAccessSection extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  apartment!: ApartmentDTO;

  applyToAllTheResidents: boolean = false;
  apartmentGates: string[] = []

  get initialApartmentGates(): string[] {
    if(this.currentEntrancePlant.gates && this.apartment && this.apartment.apartmentId)
      return this.currentEntrancePlant.gates.filter(c => c.apartments?.includes(this.apartment.apartmentId!)).map(c => c.gateId!) ?? [];
    return []
  }

  get currentEntrancePlantGatesCount() {
    return this.currentEntrancePlant.gates?.length ?? 0;
  }

  mounted(): void {
    this.apartmentGates = this.initialApartmentGates.map(a => a);
  }
}
